import fetchJSON from './utils/fetchJSON.js';
import getFetchOptions from './utils/getFetchOptions.js';
const options = {
  credentials: 'omit',
  method: 'GET',
  circuitBreaker: {
    id: 'drSettings',
    timeout: 5000,
    resetTimeout: 300000,
    fallback: {
      error: 'Circuit Breaker for /drsettings/mmdId is open'
    }
  },
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  },
  retryOn: [504],
  // Gateway Timeout
  retries: 1,
  retryDelay: 500
};
function getDrSettingsFetcher(getPath, environment) {
  const hosts = {
    prod: 'www.kbb.com',
    staging: 'staging.kbb.com'
  };
  const path = getPath(environment, hosts);
  return {
    path: path + 'my-wallet/dr-settings/mmdId',
    async fetch(dealerId, sponsor) {
      let vehicleType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'used';
      try {
        const sponsorQuery = sponsor ? `?sponsor=${sponsor}` : '';
        const endpoint = `${this.path}/${dealerId}/${vehicleType?.toLowerCase()}${sponsorQuery}`;
        return await fetchJSON(endpoint, getFetchOptions(options));
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching dealer settings: ', error);
      }
      return {};
    }
  };
}
export { getDrSettingsFetcher as default };
